import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color, border } from '@metro-ui/tokens/js';
export var Border = styled.div(function (_a) {
    var hasBorder = _a.hasBorder;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), hasBorder && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        border: ", " solid ", ";\n        border-radius: ", ";\n        overflow: hidden;\n      "], ["\n        border: ", " solid ", ";\n        border-radius: ", ";\n        overflow: hidden;\n      "])), border.width.thin, color.palette.grey.tint[80], border.radius.medium));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Border.js.map